import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { didgroupForm } from '../../dids/model/did.model';

@Component({
  selector: 'app-did-group',
  templateUrl: './did-group.component.html',
  styleUrls: ['./did-group.component.css']
})
export class DidGroupComponent implements OnInit {
  form :FormGroup
  submitted: boolean=false;
  edit:any=0
  cdata: any;
  get f() { return this.form.controls; }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DidGroupComponent>,protected fb: FormBuilder) {
    this.edit = this.data.edit
    if(this.edit){
      this.cdata = new didgroupForm(this.data.data);
       this.form = this.cdata.makeform(this.fb);
    }
    else{
      this.cdata = new didgroupForm(null);
       this.form = this.cdata.makeform(this.fb);
    }
   }

  ngOnInit() {
    console.log(this.data);
    
  }
  onSubmit(){
    this.submitted=true
    console.log(this.form.invalid);
    if (this.form.invalid) {
        return;
    }

      this.dialogRef.close(this.form.value)
    
  }

   close(){
    this.dialogRef.close(this.form.value.group_name);
   }
}
